export const NS_PER_HOUR = 1e9 * 3600;

export const NS_PER_DAY = NS_PER_HOUR * 24;

export function formatWarnBeforeNs(ns: number): string {
  if (ns <= 0 || !Number.isFinite(ns)) return "";
  const h = ns / NS_PER_HOUR;
  if (h >= 48) return `${Math.round(h / 24)} j`;
  if (h >= 1) return `${h >= 10 ? Math.round(h) : parseFloat(h.toFixed(1))} h`;
  const m = Math.round(ns / (1e9 * 60));
  return `${m} min`;
}

export function formatWarnBeforeAsDays(ns: number): string {
  if (ns <= 0 || !Number.isFinite(ns)) return "";
  const d = Math.round(ns / NS_PER_DAY);
  return d > 0 ? `${d} j` : "< 1 j";
}

export function warnDaysToGoDurationString(days: number): string {
  if (!Number.isFinite(days) || days <= 0) return "";
  return `${Math.round(days * 24)}h`;
}
